import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const wrapper = theme => css`
  width: ${rem(32)};
  height: ${rem(32)};
  font-size: ${theme.fontSize.x3large};
  color: ${theme.color.info['700']};
  background-color: ${theme.color.monochrome.white};
  border-radius: 100%;
  border: 1px solid ${theme.color.monochrome.medium};
`

export const styles = {
  wrapper,
}
